export default __webpack_public_path__ + "static/media/element_22.37d32141.webp";